import Img from "../../assets/img/amoTooltip/amo1.png";
import Img2 from "../../assets/img/amoTooltip/amo2.png";
import Img3 from "../../assets/img/amoTooltip/amo3.png";
import Img4 from "../../assets/img/amoTooltip/amo4.png";
import Img5 from "../../assets/img/amoTooltip/amo5.png";

import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataAmo = [
  {
    title: "Перейдите в “AmoMarket“",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Необходимо совершить вход в AmoCRM.</li>
        <li>Перейти в раздел “AmoMarket“.</li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Перейдите в раздел “Создать интеграцию”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          В открывшейся странице в верхнем правом углу нажмите на три точки.
        </li>
        <li>В открывшемся меню выберите "Создать интеграцию".</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Выберите тип интеграции",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В открывшемся блоке выберите "Внешняя интеграция".</li>
        <li>Нажмите на кнопку "Создать".</li>
      </ul>
    ),
    imgSrc: Img3,
  },
  {
    title: "Заполните необходимые поля",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          В появившейся форме, вам необходимо указать Название интеграции,
          выбрать требуемые доступы и указать описание.
        </li>
        <li>
          Также необходимо указать Redirect URI – url страницы получения токенов
          и загрузить логотип интеграции.
        </li>
      </ul>
    ),
    imgSrc: Img4,
  },
];

export const stepsDataAmoApiUrl = [
  {
    title: "Скопируйте ссылку",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Откройте AmoCRM в браузере.</li>
        <li>
          В адресной строке будет ссылка вида: <br />{" "}
          https://ваш_домен.amocrm.ru/dashboard/?sel=all&period=week
        </li>
        <li>
          Скопируйте только часть ссылки до первого слэша после .ru, то есть:{" "}
          <br /> https://ваш_домен.amocrm.ru
        </li>
        <div>
          * вместо <strong>ваш_домен</strong> у вас будет индивидуальное имя,
          например <strong>companyname.amocrm.ru</strong>. Не копируйте
          остальную часть ссылки.
        </div>
      </ul>
    ),
    imgSrc: Img5,
  },
];
